import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import dataLetheCityImg from "./dataLetheCityImg.json";

//

// fade animation related AOS
import Aos from "aos";
import "aos/dist/aos.css";
//
// zoom in related
import { motion } from "framer-motion";
//<motion.  add this to any img you want to scale

// the banner top vid to be put in the src: import videoCityBanner from "../../img_3d_LetheCity/founta__good.mp4";
import videoCity1 from "../../img_3d_LetheCity/vodanova_extrait_1.mp4";
import VideoCityMono1 from "../../img_3d_LetheCity/letheCity_vodanova_extrait_2.mp4";
//
import imgBannerVideo from "../../img_3d_LetheCity/lethe_intro.png";
import ImgLetheCity1 from "../../img_3d_LetheCity/jung8.jpg";

//
//
// IMAGES 2 gallery
// imgBottom1
const imgMiddle1 = {
  img1: "img_3d_LetheCity/jung8.jpg",
  alt1: "image city Organic",
};
// imgMiddle2
const imgMiddle2 = {
  img2: "img_3d_LetheCity/jung6__1.jpg",
  alt2: "image city Organic",
};
//
//

//

const LetheCityGrid = ({ setSelectedImgLetheCity }) => {
  //
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //

  //
  //
  const imageCardLetheCity = dataLetheCityImg;
  // console.log(imageCards);
  const { img1, alt1 } = imgMiddle1;
  const { img2, alt2 } = imgMiddle2;
  /*
  
  
  
  
  
  
  */

  return (
    <>
      {/* I reused the section home and the wrapper because it will economise me
    lines of code */}
      <section id="letheCity">
        <div className="letheCity___wrapper">
          {/* -------  */}
          {/* HEADER  */}
          {/* ------- */}

          {/* 
          
          
          */}
          <div className="header__Top1">
            {/* heading */}{" "}
            <div className="header__Top1__title">
              <h1 data-aos-duration="1000" data-aos="fade-up">
                LETHE CITY
              </h1>
            </div>
            <div className="header__Top1__titleTab">
              <h2> Selected Works:</h2>
              <p> 2021</p>
            </div>
          </div>
          {/* 
          
          
          
          
          */}
          <div className="video__hero">
            <div className="video__hero__wrapper">
              {/* VIDEO */}
              <div className="video__hero____container">
                <video
                  controls
                  poster={imgBannerVideo}
                  // ---
                  // autoPlay
                  loop
                  playsInline
                  // muted
                  className="video____box"
                  src={videoCity1}
                  type="video/mp4"
                ></video>
              </div>
            </div>
          </div>

          {/* 
          
          
          
          */}
          {/*   Descript ROW */}
          <div className="descript__row">
            <div className="descript__row__wrapper">
              <div className="descript__row_heading">
                <h1 data-aos-duration="1000" data-aos="fade-up">
                  PREFACE
                </h1>
                <h2>Below:</h2>
                {/* <h3>The Simurgh Mount </h3> */}
                <br />
                <p>Art Direction</p>
                <p> Modeling - Blender</p>
                <p> Texturing - Blender</p>
                <p> Lighting - Blender</p>
                <p>Rendering - Blender</p>
                <p>Video &#x26; Sound </p>{" "}
              </div>
              <div className="descript__row_article">
                <h1>
                  <br />
                  Lethe City is inspired by the ancient greek river that flowed
                  through Hypnos' cave,
                  <span>the god of sleep and creator of dreams</span>
                  The water was said to cause forgetfulness and oblivion.
                </h1>

                <h1>
                  <br />
                  The name for the city was chosen because the Senate, whose 7
                  members rule unanimously, keep their power by inducing
                  forgetfulness in their citizens.
                  <span>
                    Due to their advanced technology and research in
                    Neurobiology and Oneirology (the scientific study of
                    dreams),
                  </span>
                  Lethe specializes in the manufacturing of artificial dreams,
                  which has become the most popular, as well as legal,
                  recreational occupation of their region.
                </h1>
              </div>
            </div>
          </div>
          {/* 
               
               
               
               
               */}
          <div id="cityOrganic__imgMiddle">
            <div className="cityOrganic__imgMiddle_wrapper">
              <div className="cityOrganic__imgMiddle_container">
                <div className="boxImg">
                  <img src={img1} alt={alt1} />
                </div>
                <div className="boxImg">
                  <img src={img2} alt={alt2} />
                </div>
              </div>
            </div>
          </div>

          {/*
           
           
           
           */}
          {/* descript COL*/}

          <div className="descript__col">
            <div className="descript__col_container">
              <h1>
                Though it is widely
                <span className="underline_border">
                  considered to be a paradise by their citizens, they are
                  unaware that their free will is robbed{" "}
                </span>{" "}
                by the Senate, who keep them complacent by issuing idyllic and
                Utopian dreams.
              </h1>
              <p>
                <br />
                These dreams are non-officially named Angels Tears, or Tears
                (from the plant Angels Trumpet i.e. Brugmansia arborea).
                <span className="underline">
                  The quality and authenticity of the Angels Tears ensure that
                  their citizens are unable to protest, and rise against the
                  tyrannical system,
                </span>
                by making them forget about any injustice they notice in their
                society, clouding their judgment in the endless joy found in the
                artificial dreams.
              </p>
              <p>
                <br />
                Thus the Senate can rule without issues, though
                <span className="underline">
                  they are aware that a certain group of civilians has begun to
                  rebel against their system
                </span>{" "}
                . They call themselves the Punic. They are comprised of people
                who, through the overuse of the synthetic dreams or sheer
                willpower, have become immune to the effects of these Tears.
                Though the Senate has tried numerous times to crush the
                rebellion, they have had little to no success, as the Leaders of
                the Punic managed to develop a serum that counterattacks the
                effects of the Angels Tears.
              </p>
              {/*  */}{" "}
              <Link to="/Process">
                <h2
                  data-aos="fade-down"
                  data-aos-duration="1000"
                  className="underline"
                >
                  <span> See More</span>
                </h2>
              </Link>
            </div>
          </div>
          {/* 
          
          
          
          
          */}
          {/* ---------- */}
          <div className="folio_BG_scroll">
            {/* heading */}
            <div className="folio_BG_scroll_containerImg"></div>
          </div>
          {/* 
          
          
          
          
          */}
          {/* ---------- */}
          {/*   Descript ROW */}
          <div className="descript__row">
            <div className="descript__row__wrapper">
              <div className="descript__row_heading">
                <h1 data-aos-duration="1000" data-aos="fade-up">
                  PREFACE
                </h1>
                <h2>Below:</h2>
                {/* <h3>The Simurgh Mount </h3> */}

                <p>Software used: </p>
                <p> Blender and Photoshop</p>
              </div>
              <div className="descript__row_article">
                <h1>
                  <br />
                  The first time I thought about creating a Dystopian city was
                  back in
                  <Link to="/CityOrganic">
                    <span className="link">2016,</span>
                  </Link>
                  when I was completing a short course in 3D Design. I had
                  decided
                  <span>
                    to branch out into a new field after nearly a decade of
                    working in the art world, and I wanted to incorporate my
                    artworks in other ways
                  </span>
                  that I was used to. So I decided to test if they could be done
                  in 3ds max
                </h1>

                <h1>
                  Which to my surprise, worked pretty well. The only problem
                  that limited my capabilities back then was the fact that if I
                  wanted to create something as extensive as the city, I would
                  need more efficient hardware.{" "}
                </h1>
              </div>
            </div>
          </div>

          {/* 
          
          
    
          
          */}

          {/*   MODAL */}
          {/* --------------- */}

          <motion.div
            id="ModalBox__LetheCity"
            data-aos-duration="1000"
            data-aos="fade-down"
          >
            <div className="ModalBox__LetheCity__Wrapper">
              {/* ------ */}
              <div className="ModalBox__LetheCity__Wrapper__Grid_container">
                {imageCardLetheCity &&
                  imageCardLetheCity.map((imgItemLetheCity) => (
                    <div
                      className="img_LetheCityGallery1_card"
                      key={imgItemLetheCity.id}
                      onClick={
                        () => setSelectedImgLetheCity(imgItemLetheCity.img1)
                        // if this line below is not similar to what you have for value in the json file of this grid, it will not open the image on click
                      }
                    >
                      <img
                        src={imgItemLetheCity.img1}
                        alt={imgItemLetheCity.alt}
                      />
                    </div>
                  ))}
                {/* ------------- */}
              </div>
            </div>
          </motion.div>
          {/* ------------------------ */}
          {/* descript COL*/}

          <div className="descript__col">
            <div className="descript__col_container">
              <h1>
                Unfortunately, some personal matters forced me to pause the
                project for a couple of years , and I’ve only been able to
                dedicate some time to it since the beginning of April 2021. The
                Hiatus forced me to look at many of my previous ideas from
                another perspective, and after some thought_
                <span className="underline_border"> </span>{" "}
              </h1>
              <p>
                {" "}
                <br></br>I realized that I didn’t just want to adapt my sketches
                into 3d, but build a whole world around it, including a story
                that would make anyone understand my work with more depth than
                they would have been able to before. So after some
                consideration, I decided to collaborate with a friend, who not
                only has more experience with world-building but is also an avid
                mythology enthusiast as well as an aspiring game designer. We
                combined our knowledge in history, warfare, mythology, and
                botany and created this summary of the city Lethe.
              </p>
              {/*  */}{" "}
              <Link to="/Process">
                <h2
                  data-aos="fade-down"
                  data-aos-duration="1000"
                  className="underline"
                >
                  <span> See More</span>
                </h2>
              </Link>
            </div>
          </div>
          {/* 
          
          
          
          
          */}
          <div className="video__hero">
            <div className="video__hero__wrapper">
              {/* VIDEO */}
              <div className="video__hero____container">
                <video
                  controls
                  poster={ImgLetheCity1}
                  // ---
                  // autoPlay
                  loop
                  playsInline
                  // muted
                  className="video____box"
                  src={VideoCityMono1}
                  type="video/mp4"
                ></video>
              </div>
            </div>
          </div>
          {/* ------------------------ */}

          {/* <div id="letheCity__video__bottom">
            <div className="letheCity__videoSectionWrapper">
              <div className="letheCity__video__wrapper">
                <div className="letheCity__video__container">
                  <video
                    controls
                    poster={ImgLetheCity1}
                    // ---
                    // autoPlay
                    loop
                    playsInline
                    // muted
                    className="letheCity__video__box"
                    src={VideoCityMono1}
                    type="video/mp4"
                  ></video>
                </div>
              </div>
            </div>
          </div> */}
          {/* 
        // 
        //  
        
        
        
        
        */}
        </div>
      </section>
    </>
  );
};

export default LetheCityGrid;
